import { BaseAPI } from '../base.api';
import VeiculoTransportadora from '@/models/veiculoTransportadora';
import { VUE_APP_SIT_PEDIDOS_API_URL } from "@/commons/config"
import { AxiosObservable } from 'axios-observable/dist/axios-observable.interface';
import { Pedido, PagePedidoInput, CreateInclusaoVeiculoPayload } from '@/models/sit-pedido/pedido';
import { InputCreatePedido, DocumentoAnexo } from '@/store/modules/renovacao-crlv';


export class EnderecoAPI extends BaseAPI<any> {
   constructor() {
     super()
    this.apiUrl = `${VUE_APP_SIT_PEDIDOS_API_URL}/api/pedidos`
  }

  public findByZipCode(zipcode: string): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/transportadora/endereco-cep`, { cep: zipcode })
  }

  public listAllStates(): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/transportadora/list-ufs`)
  }

  public listAllCities(): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/transportadora/list-municipios`)
  }

  public listAllDistrictsByCityId(cityId: number): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/transportadora/list-bairros`, { id: cityId })
  }
}
